import React, { useState, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Button } from '@mui/material';
import { SubTitle } from '../common';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import LoginBG from '../../../Assets/Svg/login-bg.svg';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import { useMediaQuery } from '@mui/material';
import { AuthContext } from '../../../Context/authContext';
import KenLoader from '../../../Components/KenLoader';
import KenButton from '../../../Components/KenButton';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },
  },
  loginContent: {
    backgroundColor: 'white',
    minWidth: '636px',
    minHeight: '520px',
    alignItems: 'center',
    borderRadius: '16px',
    padding: '100px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '48px 32px',
      margin: '20px',
      minWidth: '363px',
    },
  },
  subTitle: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    margin: '0 auto 20px',
    display: 'block',
    textAlign: 'center',
    marginTop: '20px',
  },
  logo: {
    height: 54,
  },
  logoCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 20,
  },
}));

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [pageLoader] = useState(false);
  const { dispatch } = useContext(AuthContext);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box>
      {/* Conditionally render background image */}
      {!isSmallScreen && (
        <Box
          style={{
            position: 'relative',
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '100vw',
            backgroundImage:
              'url("https://iimustorageprod.blob.core.windows.net/iimu-data/LG1.png")',
          }}
        />
      )}

      {/* Always render login content */}
      <Box
        className={classes.container}
        style={{
          position: 'absolute',
          top: '50%',
          left: isSmallScreen ? '50%' : '80%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {pageLoader && <KenLoader />}
        <Box
          className={classes.loginContent}
          display={'flex'}
          flexDirection="column"
          justifyContent={'flex-start'}
          alignItems="flex-start"
        >
          <Box className={classes.logoCenter}>
            <img
              style={{
                height: '150px',
                marginTop: '60px',
                borderRadius: '12px',
                width: '200px',
                
              }}
              src="https://i.pinimg.com/736x/08/75/36/087536c5fd0ee3ddf9f2eb48afc03620.jpg"
              className={classes.logo}
              alt=""
            />
          </Box>
          <SubTitle
            className={classes.subTitle}
            text="Please click below to get started."
          />

          <KenButton
            variant="contained"
            color="primary"
            sx={{ mt: 3, width: '150px' }}
            fullWidth
            onClick={() => {
              navigate('/new-forms');
            }}
          >
            Get Started
          </KenButton>
        </Box>
      </Box>
    </Box>
  );
}
